// Re-export all constants
export * from "./modalities";
export * from "./sessions";
export * from "./themes";
export * from "./spdSubtypes";
export * from "./imageRole";
export * from "./profileImageGate";
export * from "./generationLimitGate";
export * from "./onboardingDemoGate";

// API configuration constants
export const API_BASE_URL =
  (typeof process !== "undefined" && process.env?.VITE_API_BASE_URL) ||
  "http://localhost:3001/api";

export const API_ENDPOINTS = {
  // Authentication
  AUTH: {
    LOGIN: "/auth/login",
    LOGOUT: "/auth/logout",
    REFRESH: "/auth/refresh",
    ME: "/auth/me",
  },

  // Clients
  CLIENTS: {
    LIST: "/clients",
    CREATE: "/clients",
    GET: (id: string) => `/clients/${id}`,
    UPDATE: (id: string) => `/clients/${id}`,
    DELETE: (id: string) => `/clients/${id}`,
  },

  // Sessions
  SESSIONS: {
    LIST: (clientId: string) => `/clients/${clientId}/sessions`,
    CREATE: (clientId: string) => `/clients/${clientId}/sessions`,
    GET: (clientId: string, sessionId: string) =>
      `/clients/${clientId}/sessions/${sessionId}`,
    UPDATE: (clientId: string, sessionId: string) =>
      `/clients/${clientId}/sessions/${sessionId}`,
    DELETE: (clientId: string, sessionId: string) =>
      `/clients/${clientId}/sessions/${sessionId}`,
  },

  // Images
  IMAGES: {
    GENERATE: "/images/generate",
    LIST: (sessionId: string) => `/sessions/${sessionId}/images`,
    GET: (imageId: string) => `/images/${imageId}`,
    DELETE: (imageId: string) => `/images/${imageId}`,
  },

  // Boards
  BOARDS: {
    CREATE: (sessionId: string) => `/sessions/${sessionId}/boards`,
    GET: (boardId: string) => `/boards/${boardId}`,
    UPDATE: (boardId: string) => `/boards/${boardId}`,
    DELETE: (boardId: string) => `/boards/${boardId}`,
    EXPORT: (boardId: string) => `/boards/${boardId}/export`,
  },
} as const;

// Validation constants
export const VALIDATION_RULES = {
  CLIENT: {
    FIRST_NAME: {
      MIN_LENGTH: 1,
      MAX_LENGTH: 50,
    },
    AGE: {
      MIN: 0,
      MAX: 120,
    },
    NOTES: {
      MAX_LENGTH: 1000,
    },
  },
  SESSION: {
    NOTES: {
      MAX_LENGTH: 2000,
    },
    DURATION: {
      MIN_MINUTES: 15,
      MAX_MINUTES: 180,
    },
  },
  IMAGE: {
    PROMPT: {
      MIN_LENGTH: 10,
      MAX_LENGTH: 500,
    },
    MAX_GENERATION_ATTEMPTS: 3,
  },
  BOARD: {
    TITLE: {
      MIN_LENGTH: 1,
      MAX_LENGTH: 100,
    },
    DESCRIPTION: {
      MAX_LENGTH: 500,
    },
    MAX_IMAGES: 20,
  },
} as const;

// Default pagination settings
export const PAGINATION = {
  DEFAULT_PAGE: 1,
  DEFAULT_LIMIT: 20,
  MAX_LIMIT: 100,
} as const;

// Image generation defaults
export const IMAGE_GENERATION = {
  DEFAULT_SIZE: "512x512",
  DEFAULT_QUALITY: "standard",
  DEFAULT_STYLE: "vivid",
  TIMEOUT_MS: 30000,
} as const;
